export enum KanbanCardDateField {
  CREATED_AT = "CREATED_AT",
  CLOSED_AT = "CLOSED_AT",
  CLOSING_DATE = "CLOSING_DATE",
}
